import React, { Component } from 'react'
import Icici733BalanceUpdateModalUI from './Icici733BalanceUpdateModalUI'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class Icici733BalanceUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: [],
      submitted: false,

      updatedBalance: this.props.currentBalance || '',
      updatedBalanceError: null,
    }
  }

  render() {
    return (
      <Icici733BalanceUpdateModalUI
        context={this.props.context}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={(list) => this.setState({ errorList: list })}
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        updatedBalance={this.state.updatedBalance}
        onUpdatedBalanceChange={(event) => this.setState({ updatedBalance: event.target.value })}
        updatedBalanceError={this.state.updatedBalanceError}
        setUpdatedBalanceError={(error) => this.setState({ updatedBalanceError: error })}
      />
    )
  }

  componentDidUpdate(prevProps) {
    // When dialog is opened, initialize/refresh the field and clear messages
    if (this.props.updateMode && !prevProps.updateMode) {
      this.setState({
        updatedBalance: this.props.currentBalance || '',
        updatedBalanceError: null,
        successMsg: null,
        errorList: []
      })
    }
    // When dialog is closed, clear transient state
    if (!this.props.updateMode && prevProps.updateMode) {
      this.setState({
        submitted: false,
        successMsg: null,
        errorList: [],
        updatedBalanceError: null
      })
    }
  }

  onSubmit = (event) => {
    event.preventDefault()
    if (this.state.submitted) return
    const newNumeric = parseFloat(((this.state.updatedBalance + '').trim().replace(/[^0-9.-]/g, '')))
    if (isNaN(newNumeric)) {
      this.setState({ updatedBalanceError: 'Required' })
      return
    }

    /*const currentNumeric = parseFloat((((this.props.currentBalance || '') + '').replace(/[^0-9.-]/g, ''))) || 0
    if (newNumeric === currentNumeric) {
      this.setState({ 
        updatedBalanceError: 'Value not changed',
        errorList: ['Value not changed']
      })
      return
    }*/

    if (newNumeric === 0) {
      this.setState({ 
        updatedBalanceError: 'Value cannot be 0',
        errorList: ['Value cannot be 0']
      })
      return
    }

    this.setState({ submitted: true, errorList: [], successMsg: null })
    RestApiUtils.patch(this.props.context, `/api/su/externalApiCallLog/updateICICIBalance?updatedBalance=${encodeURIComponent((this.state.updatedBalance + '').trim())}` , this.onSubmitCallback)
  }

  onSubmitCallback = (response) => {
    this.setState({ submitted: false, errorList: response.errorList || [] })
    if (!(response && response.errorList && response.errorList.length > 0)) {
      this.setState({ successMsg: 'Updated successfully', updatedBalance: '' })
      if (this.props.onSuccess) this.props.onSuccess(response)
    }
  }
}

export default Icici733BalanceUpdateModalSF


